module.exports = __webpack_public_path__ + "static/whitewaffle-d50b93e9746bab79de1f873152c72ccd.jpeg";